export default __webpack_public_path__ + "static/media/leavesBorder.5e93ac23.svg";